module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAmgAAAJoB3TZBEQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAACxSURBVEiJ1dYxagJAFEXRg0UC1gZ7FyDoQgKuJZAiW3AFQtZgLQiCu5CAKxBE7OXbOAiSFKKvyIdbX5g389+oKuhijj0WmFSVZ+AimKJuWGP0LMH6F0HhhG/0HxVs/hA0jvjEa0rQ2N6bz72CxgrDpKDlM8NbStA44AMvKUHjB+9JQWOJQVJQ2GFcVToy08MXYoLrpI/oX4Ucu6axhxZdFbFlF1vXDxdOvDLjpR/7tpwB7jilfuSOPjYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/right-arrow-black-triangle.png
// module id = +ORf
// module chunks = 1